import React from 'react';

import { TravelerAlertSettings } from '../../types/tripGroup';
import { StyledSwitch } from '../../components/forms/Switch';

interface TravelerTripAlertsProps {
  travelerTripAlertSettings: TravelerAlertSettings;
  setTravelerAlertSettings: (
    settings: TravelerAlertSettings | ((settings: TravelerAlertSettings) => TravelerAlertSettings),
  ) => void;
  isOverridden: boolean;
}

export const TravelerTripAlertsSection: React.FC<TravelerTripAlertsProps> = ({
  travelerTripAlertSettings,
  setTravelerAlertSettings,
  isOverridden,
}) => {
  return (
    <>
      <h4>Traveler Trip Alerts</h4>
      <StyledSwitch
        text="Traveler Trip Alert Enabled"
        helperText="Travelers will receive email invitations to sign up for Traveler Trip Alerting. Travelers 
        who have opted in will receive alerts"
        on={travelerTripAlertSettings.sendTravelerAlerts}
        isDisabled={!isOverridden}
        onChange={(val: boolean) => {
          setTravelerAlertSettings(settings => {
            return { ...settings, sendTravelerAlerts: val };
          });
        }}
      />
      <StyledSwitch
        text="Trip Reminders Enabled"
        helperText="Travelers will receive a trip reminder prior to departure of each leg in their trip"
        on={travelerTripAlertSettings.sendTripReminderAlerts}
        isDisabled={!isOverridden}
        onChange={(val: boolean) => {
          setTravelerAlertSettings(settings => {
            return { ...settings, sendTripReminderAlerts: val };
          });
        }}
      />
    </>
  );
};
